export const MAX_BETSLIP_SELECTIONS_SIZE = 50

// 超过30 folds后不允许用户进入All Multiple界面
export const ALL_MULTIPLE_SELECTIONS_LIMIT = 30

export const MAX_COUNT_BET_BUILDER = 10

// 最大组合数
export const MAX_BETSLIP_COMBOS = 20000
